"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCycle = void 0;
const useGenericCycle_1 = require("../useGenericCycle");
/**
 * @deprecated use useGenericCycle instead
 * @see {@link useGenericCycle}
 */
exports.useCycle = useGenericCycle_1.useGenericCycle;
